import React, { lazy } from 'react'
import Loadable from 'app/components/Loadable/Loadable';
const BatchClosingStock = Loadable(lazy(() => import("./BatchClosingStock")));


const BatchClosingStockRoutes = [
    {
        path: '/BatchClosingStock',
        element: <BatchClosingStock />,
    },
]

export default BatchClosingStockRoutes